import useSignInWithProviderCredentials from './useSignInWithProviderCredentials'

export default useSignInWithProviderCredentials
